import {handleActions} from 'redux-actions';
import humanizeString from 'humanize-string';

import {CONTENT_TYPES_SET} from './ContentTypesActions';

export const mapValuesToOptions = (e: any) => ({
    value: e,
    label: humanizeString(e).toLowerCase(),
});

export const setContentTypes = (state: any, {payload}:any) => {
    if (payload)
        return {
            isLoading: false,
            data: payload.map(mapValuesToOptions),
        };
    
    return {
        ...state,
        isLoading: false,
    };
};

export const initialState = {
    data: null,
    isLoading: true,
};

const handlers = {
    [CONTENT_TYPES_SET]: setContentTypes,
};

export default handleActions(handlers, initialState);
